<template>
  <div class="sidebar"
       :data-color="backgroundColor">

    <div class="logo">
      <a href="/" class="simple-text logo-mini">
        <div class="logo-image">
          <img :src="logo">
        </div>
      </a>

      <a href="/" class="simple-text logo-normal">
        {{title}}
      </a>
      <div class="navbar-minimize">
        <button id="minimizeSidebar" class="btn btn-simple btn-icon btn-neutral btn-round" @click="minimizeSidebar">
          <i class="now-ui-icons text_align-center visible-on-sidebar-regular"></i>
          <i class="now-ui-icons design_bullet-list-67 visible-on-sidebar-mini"></i>
        </button>
      </div>
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot></slot>
      <ul class="nav">
        <slot name="links">
          <template v-for="(link, index) in sidebarLinks">
            <sidebar-item  :key="link.name + index" :link="link" v-if="hasRole(link.roles, link.name)">
              <template v-for="(subLink, index) in link.children">
                <sidebar-item  :key="subLink.name + index" :link="subLink"  v-if="hasRole(subLink.roles, subLink.name)"></sidebar-item>
              </template>
            </sidebar-item>
          </template>
        </slot>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'sidebar',
  props: {
    title: {
      type: String,
      default: 'KJU Admin App'
    },
    backgroundColor: {
      type: String,
      default: 'black',
      validator: value => {
        let acceptedValues = [
          '',
          'blue',
          'primary',
          'green',
          'orange',
          'red',
          'purple',
          'black'
        ];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    logo: {
      type: String,
      default: '/img/icon-vue.png'
    },
    sidebarLinks: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: true
    },
    userRoles: {
      type: Array,
      default: () => []
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  methods: {
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    hasRole(roles, name){
      let check = false
      if(roles && roles.length > 0){
        check = roles.some((role) => {
            return this.userRoles.includes(role)
        })
      }
      return check
    }
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
};
</script>
<style>
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
</style>
